export const en = {
  brand: { name: 'OpenSoi' },
  nav: {
    home: 'Map',
    search: 'Search',
    add: 'Add stall',
    profile: 'Profile',
    notifications: 'Alerts',
    signin: 'Sign in',
    signout: 'Sign out',
    back: 'Back',
    skip: 'Skip',
    settings: 'Settings',
  },
  lang: { toggle: 'ภาษาไทย' },
  hero: {
    title: "เปิด: what's open in your soi, right now.",
    sub: 'Live status reported by people walking past. 300+ stalls across Bangkok. Bilingual. Free.',
  },
  live: {
    now: 'Open now',
    closed: 'Closed',
    unknown: 'No fresh signal',
    just_opened: 'Just opened',
    last_report: 'last report {{minutes}} min ago',
  },
  vote: {
    open: "It's open",
    closed: "It's closed",
    success_short: 'Logged. +{{points}}',
    success_long: 'Logged. Cheers for the soi.',
    geofence: "You're too far from the stall.",
    rate_limited: 'Already voted on this stall in the last 30 min.',
    sign_in_required: 'Sign in to vote and earn points.',
    network_error: "Couldn't reach the server. Try again.",
    geo_denied: 'Allow location to vote on this stall.',
    geo_timeout: "Couldn't read your location. Try again.",
    geo_unavailable: 'Location is unavailable in this browser.',
  },
  auth: {
    title: 'Sign in to vote',
    body: 'Browsing is free. Sign in only when you want to vote, review, or save favorites.',
    google: 'Continue with Google',
    skip: 'Keep browsing',
    error: 'Sign-in failed. Please try again.',
  },
  search: {
    placeholder: 'Search stall, dish, soi…',
    empty_title: 'No matches in this soi.',
    empty_hint: 'Try a different dish, or help the next person and add the stall yourself.',
    empty_cta: 'Add it →',
    trending: 'Trending in your area',
  },
  home: {
    nearby_count_one: '{{count}} stall',
    nearby_count_other: '{{count}} stalls',
    offline_preview: 'offline preview',
    empty_hint: 'Try a different soi, or zoom out.',
    filter: {
      open_now: 'Open now',
      noodle: 'Noodle',
      grill: 'Grill',
      isan: 'Som tam · Isan',
      sweets: 'Sweets',
      late: 'Late-night',
    },
  },
  empty: {
    morning: 'Find breakfast soi',
    midday: 'Hungry yet?',
    afternoon: "Snack o'clock",
    evening: "What's open now?",
    late: 'Late-night bites',
    deep_night: 'Still hungry?',
  },
  errors: {
    offline: "We can't reach OpenSoi right now.",
    retry: 'Retry now',
    not_found: 'Stall not found.',
    page_not_found: "We couldn't find that page.",
    stall_temporarily_unavailable: "We can't load this stall right now.",
    back_to_map: 'Back to map',
  },
  profile: {
    points: 'Points',
    next_badge_hint: 'Next badge by voting more.',
    badges: 'Badges',
    no_leaderboard: 'No public leaderboards. Badges are for you.',
    data_account: 'Data & account',
    view_privacy: 'View privacy',
    delete_account: 'Delete account',
    pdpa_note: 'Account deletion anonymizes your votes and reviews within 30 days (PDPA).',
    stats: {
      reports: 'Reports',
      reviews: 'Reviews',
      stalls_added: 'Stalls added',
    },
  },
  onboarding: {
    slide1_title: 'Live "is it open now?"',
    slide1_body:
      "People walking past Bangkok's best stalls vote once. You see it in real-time. Nobody walks to a closed cart again.",
    slide2_title: 'Geo-fenced to your soi',
    slide2_body:
      'You can only vote within 100 meters of a stall. It keeps the signal honest. Browsing is free and anonymous.',
    slide3_title: 'Earn points for the soi',
    slide3_body:
      'Vote, review, add a missing stall — get points and badges. No leaderboards, no shouting. Just the warm feeling of helping the next hungry person.',
    next: 'Next →',
    skip: 'Skip',
    finish: 'Sign in →',
  },
  add: {
    title: "Know a stall we're missing? Add it.",
    note_queue: 'Curators review new stalls within 24h. +50 points when approved.',
    step_basics: '1 · Name & dishes',
    step_location: '2 · Pin & hours',
    step_photo: '3 · One photo',
    field_name: 'Stall name',
    field_name_helper: 'EN + TH if you can. Brand and place names stay in original script.',
    field_category: 'Category',
    field_dishes: 'Famous for…',
    field_dishes_helper: 'One or two dishes the cart is known for.',
    field_hours: 'Usual hours',
    field_address: 'Address / nearest soi',
    field_address_helper: "We'll auto-detect the neighborhood from the pin.",
    photo_title: 'Add one photo',
    photo_body:
      'A clear shot of the cart helps curators approve in minutes. EXIF stripped on upload. Max 2 MB.',
    next_to_location: 'Next: Pin & hours →',
    next_to_photo: 'Next: One photo →',
    submit: 'Submit for review',
    submitting: 'Submitting…',
    back: '← Back',
    not_wired: 'Submission API is wiring up — your inputs are noted, no real submission yet.',
    name_required: 'Please add a stall name to continue.',
    pin_required: 'We need your location to pin the stall.',
    pin_locating: 'Getting your location…',
    pin_set: 'Pinned at {{lat}}, {{lng}}',
    pin_waiting: 'Tap Next to use your current location.',
    photo_required: 'Pick one photo before submitting.',
    photo_preview_alt: 'Selected photo preview',
    photo_type_error: 'Only JPEG, PNG, or WEBP photos are accepted.',
    photo_size_error: 'Photo must be under 2 MB.',
    sign_in_required: 'Sign in to submit a stall.',
    network_error: "Couldn't reach the server. Check your connection and try again.",
    geo_denied: 'Location permission denied — enable it to pin the stall.',
    geo_timeout: 'Location lookup timed out — try again.',
    geo_unavailable: "Couldn't read your location. Try again.",
    success_pending: 'Submitted! Curators review within 24h.',
    success_published: "It's live! Thanks for adding this stall.",
  },
  reviews: {
    title: 'Write a review',
    rating_label: 'Your rating',
    tags_label: 'Tags (optional)',
    body_label: 'Your review',
    body_placeholder: 'How was it? Keep it real, no spoilers on the chef.',
    photo_label: 'Photo (optional)',
    photo_helper: 'One photo — your honest plate, not a Condé Nast shot.',
    post: 'Post review',
    posting: 'Posting…',
    cancel: 'Cancel',
    points_note: '+10 points for your first review on a stall. +5 for any subsequent edit.',
    not_wired: 'Review API is wiring up — your draft is saved locally only for now.',
    success: 'Thanks — your review is live.',
    sign_in_required: 'Sign in to post a review.',
    network_error: "Couldn't reach the server. Check your connection and try again.",
    tags: {
      worth_queue: 'Worth the queue',
      bring_friend: 'Bring a friend',
      cash_only: 'Cash only',
      spicy: 'Spicy',
      late_night: 'Late-night',
      hidden_gem: 'Hidden gem',
    },
  },
  notifications: {
    intro: 'High-signal only. We never push offers or marketing.',
    none_yet_title: "No alerts yet.",
    none_yet_body:
      "We'll ping you when a favorite stall opens, your submission is approved, or a badge unlocks.",
    what_we_send: "What we'll alert you about",
    bullets: {
      favorite_opened: 'A stall you favorited just opened',
      submission_approved: 'Your submitted stall was approved (or needs a note)',
      badge_unlocked: 'A badge you were close to unlocking just unlocked',
      weekly: 'Weekly digest, once. You can turn this off.',
    },
    promise:
      'No offers. No marketing. No "you\'ve been quiet — come back!" pings. If we send one, it\'s because something real happened in your soi.',
  },
};

export type Strings = typeof en;
